// extracted by mini-css-extract-plugin
export var avatarContainer = "_bb-0";
export var avatarTypingWave = "_bb-i";
export var gray = "_bb-f";
export var green = "_bb-c";
export var icon = "_bb-9";
export var image = "_bb-1";
export var lg = "_bb-6";
export var md = "_bb-5";
export var presenceDot = "_bb-b";
export var red = "_bb-d";
export var sm = "_bb-4";
export var status = "_bb-a";
export var typingDot = "_bb-h";
export var typingPill = "_bb-g";
export var xl = "_bb-7";
export var xs = "_bb-3";
export var xxl = "_bb-8";
export var xxs = "_bb-2";
export var yellow = "_bb-e";